import { Avatar } from "@material-ui/core";
import React from "react";
import {
  DecryptGrantType,
} from "./../../modules/ml-playlist/mylist/Columns";
import { builtInGroups } from "redux/Types";

const getSharedGroups = (classes, data, orgGroups) => {

  if (data && data.length)
{
  return (
    data && data.map((v) => {
      var orgGroup = [...(orgGroups?orgGroups:[]), ...builtInGroups]?.find((r) => r.externalRefId === v.id);
      return (orgGroup ? (
        <>
          <div className={classes.sharedUserList}>
          <Avatar
            alt={orgGroup?.name}
            src={orgGroup?.imageUrl}
            className={classes.smallAvatar}
          ></Avatar>
          <div className={classes.sharedUserListSinglePreview}>
            <div title={orgGroup?.name + " " +  (orgGroup?.bbcCompany || "") + " " + (orgGroup?.bbcDepartment || "")} className={classes.sharedUserListName}>{orgGroup?.name + " " +  (orgGroup?.bbcCompany || "") + " " + (orgGroup?.bbcDepartment || "")}</div>
          </div>
          <div title={DecryptGrantType(v.grant)} className={classes.sharedUserPermission}>
            {DecryptGrantType(v.grant)}
          </div>
        </div>
        </>
      ) : ((v.usergroupID && v.name)?(
        <>
          <div className={classes.sharedUserList}>
            <div className={classes.sharedUserListSinglePreview}>
              <div title={v.name} className={classes.sharedUserListName}>{v?.name}</div>
            </div>
          </div>
        </>
      ):null)
      )
      // return (
      //   <div className={classes.sharedUserList}>
      //     <Avatar
      //       alt={orgGroup?.name}
      //       src={orgGroup?.imageUrl}
      //       className={classes.smallAvatar}
      //     ></Avatar>
      //     <div className={classes.sharedUserListSinglePreview}>
      //       <div title={orgGroup?.name + " " +  (orgGroup?.bbcCompany || "") + " " + (orgGroup?.bbcDepartment || "")} className={classes.sharedUserListName}>{orgGroup?.name + " " +  (orgGroup?.bbcCompany || "") + " " + (orgGroup?.bbcDepartment || "")}</div>
      //     </div>
      //     <div title={DecryptGrantType(v.grant)} className={classes.sharedUserPermission}>
      //       {DecryptGrantType(v.grant)}
      //     </div>
      //   </div>
      // );
    })
  );
}
else{
  return <div className={classes.underConstructionMessage} >Not Shared</div>
}
};

export default ({ label, data, classes, orgGroups }) => {
  return (
    <div className={classes.sharePlaylistUsers}>
      <div title={label} className={classes.sharePlaylistUsersLabel}>{label}</div>
      <div className={classes.sharedUserListPreview}>
      {getSharedGroups(classes, data, orgGroups)}
      </div>
    </div>
  );
};
